module.exports = __webpack_public_path__ + "img/KOMY.ae04fd72.png";